import { render, staticRenderFns } from "./saleafter.vue?vue&type=template&id=8350b24a&scoped=true&"
import script from "./saleafter.vue?vue&type=script&lang=js&"
export * from "./saleafter.vue?vue&type=script&lang=js&"
import style0 from "./saleafter.vue?vue&type=style&index=0&id=8350b24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8350b24a",
  null
  
)

export default component.exports